import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import { StoryElement } from "@quintype/components";

import "../story-templates/blank.m.css";

export const AlsoRead = ({ card, story }) => {
  const cardStoryElements = get(card, ["story-elements"], []);
  const linkedStoryCollection = cardStoryElements.filter((ele) => ele.subtype === "also-read");
  return (
    <div className="story-element story-element-also-read" styleName="custom-also-read">
      <span styleName="also-read-label">Also Read</span>
      {linkedStoryCollection?.map((element) => {
        return <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />;
      })}
    </div>
  );
};

AlsoRead.propTypes = {
  card: object,
  story: object,
};
